// -----------------------
// <auto-generated>
// Generated using the script normalizrSchemaGenerator.js
// </auto-generated>
// -----------------------
import { schema } from 'normalizr';
import { ObjectsWithoutIdPropertyEnum } from './FranfinanceApiSchemaTypes';
import { BaseFranfinanceApiSchema } from './BaseFranfinanceApiSchema';

export { ObjectsWithoutIdPropertyEnum } from './FranfinanceApiSchemaTypes';
export type { ObjectsWithoutIdProperty } from './FranfinanceApiSchemaTypes';

export interface IFranfinanceEntities {
    addresses?: Record<string, unknown>;
    assetFamilies?: Record<string, unknown>;
    assetNatures?: Record<string, unknown>;
    billingAddressDetails?: Record<string, unknown>;
    billingBankDetailDetails?: Record<string, unknown>;
    billingOrderNumberDetails?: Record<string, unknown>;
    changeFinancialConditionDetails?: Record<string, unknown>;
    changeHeadOfficeAddressDetails?: Record<string, unknown>;
    contractAssets?: Record<string, unknown>;
    contractBillings?: Record<string, unknown>;
    contractInformations?: Record<string, unknown>;
    contractTransferDetails?: Record<string, unknown>;
    contracts?: Record<string, unknown>;
    customerRequestsSummaries?: Record<string, unknown>;
    documentAccountExtractDetails?: Record<string, unknown>;
    documentContractRelatedDetails?: Record<string, unknown>;
    documentCopyOfContractualElementDetails?: Record<string, unknown>;
    documentEquipmentRelatedDetails?: Record<string, unknown>;
    endOfContractDenialOfContractRenewalDetails?: Record<string, unknown>;
    endOfContractEarlyRedemptionDetails?: Record<string, unknown>;
    endOfContractExerciseOfPurchaseOptionDetails?: Record<string, unknown>;
    endOfContractReturnOfEquipmentDetails?: Record<string, unknown>;
    endOfContractTerminationOfContractDetails?: Record<string, unknown>;
    equipment?: Record<string, unknown>;
    financialRequestDetaileds?: Record<string, unknown>;
    financialRequestSummaries?: Record<string, unknown>;
    fundings?: Record<string, unknown>;
    invoices?: Record<string, unknown>;
    loggedUsers?: Record<string, unknown>;
    people?: Record<string, unknown>;
    saveFinancialResponses?: Record<string, unknown>;
    statuses?: Record<string, unknown>;
    thirdAddresses?: Record<string, unknown>;
    userInfos?: Record<string, unknown>;
}

export class FranfinanceApiSchema extends BaseFranfinanceApiSchema {
    public static AddressSchema = new schema.Entity(
        'addresses',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Address),
        });
    public static AssetFamilySchema = new schema.Entity(
        'assetFamilies',
        {},
        {
            idAttribute: 'id',
        });
    public static AssetNatureSchema = new schema.Entity(
        'assetNatures',
        {},
        {
            idAttribute: 'id',
        });
    public static BillingAddressDetailsSchema = new schema.Entity(
        'billingAddressDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.BillingAddressDetails),
        });
    public static BillingBankDetailDetailsSchema = new schema.Entity(
        'billingBankDetailDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.BillingBankDetailDetails),
        });
    public static BillingOrderNumberDetailsSchema = new schema.Entity(
        'billingOrderNumberDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.BillingOrderNumberDetails),
        });
    public static ChangeFinancialConditionDetailsSchema = new schema.Entity(
        'changeFinancialConditionDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ChangeFinancialConditionDetails),
        });
    public static ChangeHeadOfficeAddressDetailsSchema = new schema.Entity(
        'changeHeadOfficeAddressDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ChangeHeadOfficeAddressDetails),
        });
    public static ContractAssetsSchema = new schema.Entity(
        'contractAssets',
        {},
        {
            idAttribute: 'id',
        });
    public static ContractBillingSchema = new schema.Entity(
        'contractBillings',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ContractBilling),
        });
    public static ContractInformationSchema = new schema.Entity(
        'contractInformations',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ContractInformation),
        });
    public static ContractSchema = new schema.Entity(
        'contracts',
        {},
        {
            idAttribute: 'id',
        });
    public static ContractTransferDetailsSchema = new schema.Entity(
        'contractTransferDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ContractTransferDetails),
        });
    public static CustomerRequestsSummarySchema = new schema.Entity(
        'customerRequestsSummaries',
        {},
        {
            idAttribute: 'id',
        });
    public static DocumentAccountExtractDetailsSchema = new schema.Entity(
        'documentAccountExtractDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.DocumentAccountExtractDetails),
        });
    public static DocumentContractRelatedDetailsSchema = new schema.Entity(
        'documentContractRelatedDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.DocumentContractRelatedDetails),
        });
    public static DocumentCopyOfContractualElementDetailsSchema = new schema.Entity(
        'documentCopyOfContractualElementDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.DocumentCopyOfContractualElementDetails),
        });
    public static DocumentEquipmentRelatedDetailsSchema = new schema.Entity(
        'documentEquipmentRelatedDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.DocumentEquipmentRelatedDetails),
        });
    public static EndOfContractDenialOfContractRenewalDetailsSchema = new schema.Entity(
        'endOfContractDenialOfContractRenewalDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.EndOfContractDenialOfContractRenewalDetails),
        });
    public static EndOfContractEarlyRedemptionDetailsSchema = new schema.Entity(
        'endOfContractEarlyRedemptionDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.EndOfContractEarlyRedemptionDetails),
        });
    public static EndOfContractExerciseOfPurchaseOptionDetailsSchema = new schema.Entity(
        'endOfContractExerciseOfPurchaseOptionDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.EndOfContractExerciseOfPurchaseOptionDetails),
        });
    public static EndOfContractReturnOfEquipmentDetailsSchema = new schema.Entity(
        'endOfContractReturnOfEquipmentDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.EndOfContractReturnOfEquipmentDetails),
        });
    public static EndOfContractTerminationOfContractDetailsSchema = new schema.Entity(
        'endOfContractTerminationOfContractDetails',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.EndOfContractTerminationOfContractDetails),
        });
    public static EquipmentSchema = new schema.Entity(
        'equipment',
        {},
        {
            idAttribute: 'id',
        });
    public static FinancialRequestDetailedSchema = new schema.Entity(
        'financialRequestDetaileds',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.FinancialRequestDetailed),
        });
    public static FinancialRequestSummarySchema = new schema.Entity(
        'financialRequestSummaries',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.FinancialRequestSummary),
        });
    public static FundingSchema = new schema.Entity(
        'fundings',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Funding),
        });
    public static InvoiceSchema = new schema.Entity(
        'invoices',
        {},
        {
            idAttribute: 'id',
        });
    public static LoggedUserSchema = new schema.Entity(
        'loggedUsers',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.LoggedUser),
        });
    public static PersonSchema = new schema.Entity(
        'people',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Person),
        });
    public static SaveFinancialResponseSchema = new schema.Entity(
        'saveFinancialResponses',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.SaveFinancialResponse),
        });
    public static StatusSchema = new schema.Entity(
        'statuses',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Status),
        });
    public static ThirdAddressSchema = new schema.Entity(
        'thirdAddresses',
        {},
        {
            idAttribute: (value: any) => FranfinanceApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.ThirdAddress),
        });
    public static UserInfoSchema = new schema.Entity(
        'userInfos',
        {},
        {
            idAttribute: 'id',
        });

    public static AddressSchemaArray = new schema.Array(FranfinanceApiSchema.AddressSchema);
    public static AssetFamilySchemaArray = new schema.Array(FranfinanceApiSchema.AssetFamilySchema);
    public static AssetNatureSchemaArray = new schema.Array(FranfinanceApiSchema.AssetNatureSchema);
    public static BillingAddressDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.BillingAddressDetailsSchema);
    public static BillingBankDetailDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.BillingBankDetailDetailsSchema);
    public static BillingOrderNumberDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.BillingOrderNumberDetailsSchema);
    public static ChangeFinancialConditionDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.ChangeFinancialConditionDetailsSchema);
    public static ChangeHeadOfficeAddressDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.ChangeHeadOfficeAddressDetailsSchema);
    public static ContractAssetsSchemaArray = new schema.Array(FranfinanceApiSchema.ContractAssetsSchema);
    public static ContractBillingSchemaArray = new schema.Array(FranfinanceApiSchema.ContractBillingSchema);
    public static ContractInformationSchemaArray = new schema.Array(FranfinanceApiSchema.ContractInformationSchema);
    public static ContractSchemaArray = new schema.Array(FranfinanceApiSchema.ContractSchema);
    public static ContractTransferDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.ContractTransferDetailsSchema);
    public static CustomerRequestsSummarySchemaArray = new schema.Array(FranfinanceApiSchema.CustomerRequestsSummarySchema);
    public static DocumentAccountExtractDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.DocumentAccountExtractDetailsSchema);
    public static DocumentContractRelatedDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.DocumentContractRelatedDetailsSchema);
    public static DocumentCopyOfContractualElementDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.DocumentCopyOfContractualElementDetailsSchema);
    public static DocumentEquipmentRelatedDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.DocumentEquipmentRelatedDetailsSchema);
    public static EndOfContractDenialOfContractRenewalDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.EndOfContractDenialOfContractRenewalDetailsSchema);
    public static EndOfContractEarlyRedemptionDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.EndOfContractEarlyRedemptionDetailsSchema);
    public static EndOfContractExerciseOfPurchaseOptionDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.EndOfContractExerciseOfPurchaseOptionDetailsSchema);
    public static EndOfContractReturnOfEquipmentDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.EndOfContractReturnOfEquipmentDetailsSchema);
    public static EndOfContractTerminationOfContractDetailsSchemaArray = new schema.Array(FranfinanceApiSchema.EndOfContractTerminationOfContractDetailsSchema);
    public static EquipmentSchemaArray = new schema.Array(FranfinanceApiSchema.EquipmentSchema);
    public static FinancialRequestDetailedSchemaArray = new schema.Array(FranfinanceApiSchema.FinancialRequestDetailedSchema);
    public static FinancialRequestSummarySchemaArray = new schema.Array(FranfinanceApiSchema.FinancialRequestSummarySchema);
    public static FundingSchemaArray = new schema.Array(FranfinanceApiSchema.FundingSchema);
    public static InvoiceSchemaArray = new schema.Array(FranfinanceApiSchema.InvoiceSchema);
    public static LoggedUserSchemaArray = new schema.Array(FranfinanceApiSchema.LoggedUserSchema);
    public static PersonSchemaArray = new schema.Array(FranfinanceApiSchema.PersonSchema);
    public static SaveFinancialResponseSchemaArray = new schema.Array(FranfinanceApiSchema.SaveFinancialResponseSchema);
    public static StatusSchemaArray = new schema.Array(FranfinanceApiSchema.StatusSchema);
    public static ThirdAddressSchemaArray = new schema.Array(FranfinanceApiSchema.ThirdAddressSchema);
    public static UserInfoSchemaArray = new schema.Array(FranfinanceApiSchema.UserInfoSchema);

    public static initialize(): void {
        FranfinanceApiSchema.FinancialRequestDetailedSchema.define({
            equipment: FranfinanceApiSchema.EquipmentSchema,
            funding: FranfinanceApiSchema.FundingSchema,
            status: FranfinanceApiSchema.StatusSchema,
        });

        FranfinanceApiSchema.FinancialRequestSummarySchema.define({
            status: FranfinanceApiSchema.StatusSchema,
        });

        FranfinanceApiSchema.LoggedUserSchema.define({
            impersonatedBy: FranfinanceApiSchema.UserInfoSchema,
        });
    }
}

FranfinanceApiSchema.initialize();
